import { gql } from '@apollo/client'

export default gql`
  mutation deleteAssignment($id: ID!) {
    deleteAssignment(id: $id) {
      id
    }
  }
`
